import React from 'react';

export default function BlastFooter() {
  return (
    <footer
      style={{
        background: 'var(--arctic-white)',
        borderTop: '1px solid var(--mist-gray)',
        padding: '2.5rem clamp(2rem, 6vw, 6rem)',
      }}
    >
      {/* Contact Section */}
      <div
        style={{
          marginBottom: '2rem',
          paddingBottom: '2rem',
          borderBottom: '1px solid var(--mist-gray)',
          display: 'flex',
          flexWrap: 'wrap',
          gap: '1.5rem',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <div>
          <p
            style={{
              fontSize: '0.6875rem',
              fontWeight: 700,
              letterSpacing: '0.15em',
              textTransform: 'uppercase',
              color: 'var(--accent-blue)',
              fontFamily: 'Plus Jakarta Sans, sans-serif',
              marginBottom: '0.75rem',
            }}
          >
            Contact Us
          </p>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1.5rem' }}>
            <a
              href="mailto:lakecountrycleaningmn@gmail.com"
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                fontSize: '0.9375rem',
                fontWeight: 500,
                color: 'var(--slate)',
                fontFamily: 'Plus Jakarta Sans, sans-serif',
                textDecoration: 'none',
                transition: 'color 0.2s',
              }}
              onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--accent-blue)')}
              onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--slate)')}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                <polyline points="22,6 12,13 2,6" />
              </svg>
              lakecountrycleaningmn@gmail.com
            </a>
            <a
              href="tel:6129796069"
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                fontSize: '0.9375rem',
                fontWeight: 500,
                color: 'var(--slate)',
                fontFamily: 'Plus Jakarta Sans, sans-serif',
                textDecoration: 'none',
                transition: 'color 0.2s',
              }}
              onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--accent-blue)')}
              onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--slate)')}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.18 2 2 0 0 1 3.6 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.6a16 16 0 0 0 6 6l.96-.96a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
              </svg>
              612-979-6069
            </a>
          </div>
        </div>
      </div>

      <div
        className="flex flex-col sm:flex-row items-center justify-between gap-4"
      >
        {/* Logo + links */}
        <div className="flex items-center gap-8 flex-wrap">
          <span
            style={{
              fontFamily: 'DM Sans, sans-serif',
              fontWeight: 700,
              fontSize: '1rem',
              color: 'var(--slate)',
              letterSpacing: '-0.01em',
            }}
          >
            Lake Country Cleaning
          </span>
          {['Services', 'About', 'Privacy', 'Terms']?.map((link) => (
            <a
              key={link}
              href="#"
              style={{
                fontSize: '0.875rem',
                fontWeight: 500,
                color: 'var(--mist-gray)',
                fontFamily: 'Plus Jakarta Sans, sans-serif',
                textDecoration: 'none',
                transition: 'color 0.2s',
              }}
              onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--slate)')}
              onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--mist-gray)')}
            >
              {link}
            </a>
          ))}
        </div>

        {/* Right: Social + copyright */}
        <div className="flex items-center gap-6">
          {/* Social icons */}
          <div className="flex items-center gap-3">
            {[
              {
                label: 'Instagram',
                href: 'https://www.instagram.com/lakecountry_cleaning/',
                icon: (
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                    <circle cx="12" cy="12" r="4" />
                    <circle cx="17.5" cy="6.5" r="0.5" fill="currentColor" />
                  </svg>
                ),
              },
            ]?.map((social) => (
              <a
                key={social?.label}
                href={social?.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={social?.label}
                style={{
                  width: '32px',
                  height: '32px',
                  borderRadius: '50%',
                  border: '1px solid var(--mist-gray)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'var(--mist-gray)',
                  textDecoration: 'none',
                  transition: 'all 0.2s',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = 'var(--accent-blue)';
                  e.currentTarget.style.color = 'var(--accent-blue)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = 'var(--mist-gray)';
                  e.currentTarget.style.color = 'var(--mist-gray)';
                }}
              >
                {social?.icon}
              </a>
            ))}
          </div>

          <span
            style={{
              fontSize: '0.8125rem',
              color: 'var(--mist-gray)',
              fontFamily: 'Plus Jakarta Sans, sans-serif',
            }}
          >
            © 2026 Lake Country Cleaning
          </span>
        </div>
      </div>
    </footer>
  );
}